import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { selectMsaId } from 'redux/modules/features/homepage';
import { msas, promotionByAlias } from 'redux/saga/entities/bound';
import { msaByIdentifier } from 'redux/saga/selectors/msas';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { withSagas } from 'decorators/Sagas';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { decorateWith } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { ACTIONS, CallToAction } from 'components/CallToAction';
import { LocationSelector } from 'components/CmsPage/modules/LocationSelector/LocationSelector';
import { loadFreeTrialPromotion, loadSaga, watchSaga } from './FreeTrialSignup.saga';
export var FreeTrialSignupV3Unwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(FreeTrialSignupV3Unwrapped, _Component);

  function FreeTrialSignupV3Unwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FreeTrialSignupV3Unwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FreeTrialSignupV3Unwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleCta = _this.handleCta.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FreeTrialSignupV3Unwrapped, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var msa = this.props.msa;

      if (nextProps.msa !== msa) {
        this.props.loadPromotion(nextProps.msa);
      }
    }
  }, {
    key: "handleCta",
    value: function handleCta() {
      trackOptimizelyEvent('successful_plan_selection');
    }
  }, {
    key: "renderSalesPitch",
    value: function renderSalesPitch() {
      return React.createElement("section", {
        className: "sales-pitch"
      }, React.createElement("h2", {
        className: "sales-pitch__title"
      }, "A month of workouts, for free."), React.createElement("p", {
        className: "sales-pitch__description"
      }, "ClassPass gives you access to the world\u2019s top studios and gyms, so you can try cycling, yoga, boxing, and more \u2014 wherever you are."), React.createElement("picture", {
        className: "sales-pitch__image"
      }, React.createElement("source", {
        srcSet: require('./static/img/calendar.png'),
        media: "(min-width: 480px) and (max-width: 767px)"
      }), React.createElement("source", {
        srcSet: require('./static/img/calendar-mobile.png'),
        media: "(min-width: 768px) and (max-width: 899px)"
      }), React.createElement("source", {
        srcSet: require('./static/img/calendar.png'),
        media: "(min-width: 900px)"
      }), React.createElement("img", {
        src: require('./static/img/calendar-mobile.png'),
        alt: "calendar"
      })));
    }
  }, {
    key: "renderPlanCard",
    value: function renderPlanCard() {
      var classEstimateMax = this.props.classEstimateMax;
      return React.createElement("section", {
        className: "plan-card"
      }, React.createElement("header", null, React.createElement("p", {
        className: "plan-card__tag"
      }, "FREE MONTH!"), React.createElement("h2", {
        className: "plan-card__callout"
      }, "$0")), React.createElement("ul", {
        className: "plan-card__details"
      }, classEstimateMax && React.createElement("li", null, React.createElement(Isvg, {
        src: require('./static/img/muscle.svg')
      }), React.createElement("span", {
        className: "plan-card__details__detail"
      }, "Take up to ", classEstimateMax, " classes in your first month!")), React.createElement("li", null, React.createElement(Isvg, {
        src: require('./static/img/unlocked.svg')
      }), React.createElement("span", {
        className: "plan-card__details__detail"
      }, "You\u2019re never locked in. Cancel anytime."))), React.createElement("div", {
        className: "plan-card__cta"
      }, React.createElement(CallToAction, {
        action: ACTIONS.OFFER_CHECKOUT,
        color: "primary_solid",
        extraClass: "bt--lg bt--width-md",
        onClick: this.handleCta,
        promotionAlias: this.props.promotionAlias
      }, "Start your trial")));
    }
  }, {
    key: "renderAvailableLocationFinder",
    value: function renderAvailableLocationFinder() {
      return React.createElement("div", {
        className: "available-location-finder"
      }, React.createElement(LocationSelector, null));
    }
  }, {
    key: "renderDisclaimer",
    value: function renderDisclaimer() {
      var recurringPlanPrice = this.props.recurringPlanPrice;
      return React.createElement("p", {
        className: "free-trial-signup-v3__disclaimer"
      }, "After your free trial, you\u2019ll auto-enroll in our $", recurringPlanPrice, "/month plan. Change or cancel any time during your trial to not be charged.");
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("section", {
        className: "free-trial-signup-v3"
      }, React.createElement("div", {
        className: "free-trial-signup-v3__section-1"
      }, this.renderPlanCard(), this.renderAvailableLocationFinder(), this.renderDisclaimer()), React.createElement("div", {
        className: "free-trial-signup-v3__section-2"
      }, this.renderSalesPitch()));
    }
  }]);

  return FreeTrialSignupV3Unwrapped;
}(Component);
FreeTrialSignupV3Unwrapped.propTypes = {
  classEstimateMax: PropTypes.number.isRequired,
  loadPromotion: PropTypes.func.isRequired,
  msa: PropTypes.object,
  promotionAlias: PropTypes.string.isRequired,
  recurringPlanPrice: PropTypes.number.isRequired
};
export var mapDispatchToProps = {
  loadPromotion: loadFreeTrialPromotion
};
export var mapStateToProps = function mapStateToProps(state) {
  var msa = msaByIdentifier(msas.data(state), selectMsaId(state)) || {};
  var promotionAlias = GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
  var promotionKey = promotionByAlias.defaultKey(null, promotionAlias, msa.id);
  var promotion = promotionByAlias.data(state, promotionKey) || {};
  return {
    classEstimateMax: deepExtract('offers.0.initial_plan.max_class_estimate', promotion),
    msa: msa,
    promotionAlias: promotionAlias,
    recurringPlanPrice: deepExtract('offers.0.recurring_plan.price', promotion)
  };
};
export var FreeTrialSignupV3 = decorateWith(trackDwell, withSagas({
  load: loadSaga,
  watch: watchSaga
}), connect(mapStateToProps, mapDispatchToProps))(FreeTrialSignupV3Unwrapped);